import { FadeIn } from "./FadeIn";

export const AUTH_INPUT_CLS =
  "w-full bg-capra-night/60 border border-white/10 px-4 py-3.5 text-sm text-capra-ivory placeholder:text-capra-muted/50 outline-none focus:border-capra-bronze transition-colors";

export const AuthCard = ({ title, subtitle, testId, children }) => (
  <div className="min-h-screen flex items-center justify-center px-6 py-32 monogram-veil" data-testid={testId}>
    <FadeIn className="w-full max-w-md">
      <div className="leather-panel p-10 lg:p-12">
        <div className="text-center mb-10">
          <img src="/brand/goat-badge.jpg" alt="" className="mx-auto h-14 w-14 rounded-full object-cover border border-capra-bronze/50 mb-5" />
          <h1 className="font-display text-3xl text-capra-ivory">{title}</h1>
          <p className="text-xs text-capra-muted mt-2 tracking-wide">{subtitle}</p>
        </div>
        {children}
      </div>
    </FadeIn>
  </div>
);

export const GoogleAuthSection = ({ onGoogle, testId }) => (
  <>
    <div className="flex items-center gap-4 my-6">
      <div className="hairline flex-1" />
      <span className="text-[10px] uppercase tracking-[0.25em] text-capra-muted">or</span>
      <div className="hairline flex-1" />
    </div>
    <button
      data-testid={testId}
      onClick={onGoogle}
      className="w-full py-4 border border-white/15 text-capra-ivory text-[11px] uppercase tracking-[0.22em] hover:border-capra-bronze hover:text-capra-bronze transition-colors"
    >
      Continue with Google
    </button>
  </>
);
